module.exports = __webpack_public_path__ + "a45beda349e8d48756ac4c58e3a9cef9.svg";


//////////////////
// WEBPACK FOOTER
// ../images/admin/approval_queues/icons/icon-link.svg
// module id = 2095
// module chunks = 69